var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5354 10.4644C19.488 12.4171 19.488 15.5829 17.5354 17.5355M10.4643 17.5355C8.51168 15.5829 8.51168 12.417 10.4643 10.4644M8.10728 19.8925C4.85291 16.6382 4.85291 11.3618 8.10728 8.10742M19.8924 8.10746C23.1468 11.3618 23.1468 16.6382 19.8924 19.8926M15.6665 14C15.6665 14.9205 14.9203 15.6666 13.9998 15.6666C13.0794 15.6666 12.3332 14.9205 12.3332 14C12.3332 13.0795 13.0794 12.3333 13.9998 12.3333C14.9203 12.3333 15.6665 13.0795 15.6665 14Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/liveIcon.e7c033f15b82b767a985b8c333ab87f4.svg";
export { ForwardRef as ReactComponent };